export const PREDEFINED_SUBTASKS = [
  'VFA (vyšlé faktúry)',
  'DFA (došlé faktúry)',
  'Banka – príjmy aj výdaje',
  'Pokladňa – cash príjmy',
  'Pokladňa – cash výdaje',
  'Pokladňa – karta výdaje',
  'Pohľadávky',
  'Záväzky',
  'ID (interné doklady)',
  'Podanie DPH a KV k DPH',
  'Podanie DP k DPH',
  'Vystavovanie faktúr',
];
